import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from '@app/_services';
import { MessageService, ConfirmationService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { QualityTestDefinitionsService } from '../quality-test-definitions.service';
import { QualityTestFieldRegistry } from '../quality-test-field-registry';

@Component({
  selector: 'app-quality-test-field-registry-list',
  templateUrl: './quality-test-field-registry-list.component.html',
  styleUrls: ['./quality-test-field-registry-list.component.css'],
  providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
  styles: [`
    :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
      position: -webkit-sticky;
      position: sticky;
      top: 0px;
    }
  `],
  standalone: false
})
export class QualityTestFieldRegistryListComponent implements OnInit {

  fields: QualityTestFieldRegistry[] = [];
  loading = false;
  formLoading = false;

  editingField: QualityTestFieldRegistry | null = null;
  showEditDialog = false;
  editForm: UntypedFormGroup;

  columns: any[] = [
    { field: 'fieldKey', header: 'Field Key' },
    { field: 'displayName', header: 'Display Name' },
    { field: 'dataType', header: 'Data Type' },
    { field: 'dataSource', header: 'Data Source' },
    { field: 'javaPath', header: 'Java Path' },
    { field: 'allowedOperators', header: 'Allowed Operators' },
    { field: 'isActive', header: 'Active' },
  ];

  constructor(
    private service: QualityTestDefinitionsService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.loadFields();
    this.buildEditForm();
  }

  buildEditForm() {
    this.editForm = this.fb.group({
      fieldRegistryId: [null],
      fieldKey: [''],
      displayName: [''],
      description: [''],
      aliases: [''],
      dataType: [''],
      dataSource: [''],
      javaPath: [''],
      allowedOperators: [''],
      isActive: [1],
    });
  }

  loadFields() {
    this.loading = true;
    this.service.findAllFields().pipe(first()).subscribe(
      (res: any) => {
        this.fields = res.data?.qualityTestFieldRegistry || [];
      },
      (err: any) => {
        this.alertService.error(err);
      },
      () => { this.loading = false; }
    );
  }

  openAddDialog() {
    this.editingField = null;
    this.editForm.reset({ isActive: 1 });
    this.showEditDialog = true;
  }

  openEditDialog(field: QualityTestFieldRegistry) {
    this.editingField = field;
    this.editForm.patchValue(field);
    this.showEditDialog = true;
  }

  onSaveField() {
    this.formLoading = true;
    const field: QualityTestFieldRegistry = this.editForm.value;
    const isEdit = !!field.fieldRegistryId;
    const call = isEdit ? this.service.updateField(field) : this.service.addField(field);

    call.pipe(first()).subscribe(
      (res: any) => {
        this.showEditDialog = false;
        this.loadFields();
        this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Field saved.', life: 3000 });
      },
      (err: any) => {
        this.messageService.add({ severity: 'error', summary: 'Save Failed', detail: JSON.stringify(err), life: 3000 });
      },
      () => { this.formLoading = false; }
    );
  }

  onDeleteField(field: QualityTestFieldRegistry) {
    this.confirmationService.confirm({
      message: 'Delete field "' + field.fieldKey + '"?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.deleteField(field.fieldRegistryId).pipe(first()).subscribe(
          (res: any) => {
            this.fields = this.fields.filter(f => f.fieldRegistryId !== field.fieldRegistryId);
            this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Field deleted.', life: 3000 });
          },
          (err: any) => {
            this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: JSON.stringify(err), life: 3000 });
          }
        );
      },
      reject: () => { }
    });
  }
}
